<h1 mat-dialog-title>Countries mentioned in abstracts</h1>
<div mat-dialog-content>
  <div id="map"></div>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">
    <mat-icon>fullscreen_exit</mat-icon>
    Close
    </button>
</div>
